module.exports = __webpack_public_path__ + "img/react.c3ba82a5.png";